import * as React from 'react';
import {
    Edit,
    required,
    SimpleForm,
    TextInput,
    NumberInput,
    PasswordInput,
} from 'react-admin';
import DatabaseItemTitle from './DatabaseItemTitle';
import DatabaseItemTypesInput from './DatabaseItemTypesInput';

const DatabaseItemEdit = props => (
    <Edit title={<DatabaseItemTitle />} {...props}>
        <SimpleForm>
            <DatabaseItemTypesInput source="type" validate={required()} />
            <TextInput source="hostname" validate={required()} />
            <NumberInput source="port" />
            <TextInput source="username" validate={required()} />
            <PasswordInput source="password" validate={required()} />
            <TextInput source="version" />
            <TextInput source="database_list" />
        </SimpleForm>
    </Edit>
);

export default DatabaseItemEdit;